var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "generic-select",
      class: [
        { blurred: _vm.isDisabled },
        { "background-light": _vm.$route?.meta?.backgroundColor === "light" }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "label-holder" },
        [
          _c("label", {
            attrs: { for: _vm.field },
            domProps: { innerHTML: _vm._s(_vm.label) }
          }),
          _vm.hint
            ? _c("CommonHint", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "hint",
                      fn: function() {
                        return [_vm._t("hint")]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dropdown-container",
          attrs: { id: _vm.field + _vm.number }
        },
        [
          _c(
            "div",
            { staticClass: "options-container" },
            [
              _c(
                "div",
                {
                  staticClass: "dropdown-activator",
                  on: { click: _vm.openDropdown }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyWord,
                        expression: "keyWord"
                      }
                    ],
                    staticClass: "inline-search",
                    attrs: {
                      type: "text",
                      placeholder: _vm.placeholder,
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.keyWord },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.keyWord = $event.target.value
                      }
                    }
                  }),
                  _c("span", { ref: "dropArrow", staticClass: "arrow" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/drc/assets/icons/triangle-down.svg"),
                        alt: "Dropdwon"
                      }
                    })
                  ])
                ]
              ),
              _vm.notValidatedOptions?.length > 0 ||
              _vm.selectedOptions?.length > 0
                ? _c(
                    "div",
                    { staticClass: "selected-options" },
                    [
                      _vm._l(_vm.selectedOptions, function(
                        selectedOption,
                        index
                      ) {
                        return _vm.options.find(el =>
                          _vm.id
                            ? el[_vm.id] === selectedOption?.[_vm.id]
                            : el[_vm.textFieldName] ===
                              selectedOption?.[_vm.textFieldName]
                        )
                          ? _c(
                              "span",
                              {
                                key: _vm.field + "selected" + index,
                                class: [
                                  `selected-tag`,
                                  {
                                    "for-approval":
                                      selectedOption?.approvalStatus ===
                                      "FOR_APPROVAL"
                                  },
                                  {
                                    inactive:
                                      selectedOption?.approvalStatus ===
                                      "INACTIVE"
                                  }
                                ]
                              },
                              [
                                [
                                  _vm.imageUrl
                                    ? _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: require(`@/${_vm.imageUrl}${
                                            selectedOption?.[
                                              _vm.imageFieldName
                                                ? _vm.imageFieldName
                                                : _vm.textFieldName
                                            ]
                                          }.svg`)
                                        }
                                      })
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "option-name",
                                      on: {
                                        click: function($event) {
                                          return _vm.redirectForApproval(
                                            selectedOption
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.options.find(el =>
                                            _vm.id
                                              ? el[_vm.id] ===
                                                selectedOption?.[_vm.id]
                                              : el[_vm.textFieldName] ===
                                                selectedOption?.[
                                                  _vm.textFieldName
                                                ]
                                          )[_vm.textFieldName]
                                        )
                                      )
                                    ]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/drc/assets/icons/x_black.svg"),
                                      alt: "Remove"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectOption(selectedOption)
                                      }
                                    }
                                  })
                                ]
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      _vm._l(_vm.notValidatedOptions, function(
                        selectedOption,
                        index
                      ) {
                        return _vm.notValidatedOptions?.length
                          ? _c(
                              "span",
                              {
                                key: _vm.field + "notValidated" + index,
                                class: [
                                  `selected-tag`,
                                  `not-validated`,
                                  {
                                    "for-approval":
                                      selectedOption?.approvalStatus ===
                                      "FOR_APPROVAL"
                                  },
                                  {
                                    inactive:
                                      selectedOption?.approvalStatus ===
                                      "INACTIVE"
                                  }
                                ]
                              },
                              [
                                [
                                  _vm.imageUrl
                                    ? _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: require(`@/${_vm.imageUrl}${
                                            selectedOption?.[
                                              _vm.imageFieldName
                                                ? _vm.imageFieldName
                                                : _vm.textFieldName
                                            ]
                                          }.svg`),
                                          alt: "x"
                                        }
                                      })
                                    : _vm._e(),
                                  _c("span", { staticClass: "option-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        selectedOption?.[_vm.textFieldName]
                                      )
                                    )
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/drc/assets/icons/x_black.svg"),
                                      alt: "Remove"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeNotValidatedOption(
                                          selectedOption
                                        )
                                      }
                                    }
                                  })
                                ]
                              ],
                              2
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                { ref: "optionContainer", staticClass: "dropdown-options" },
                [
                  _vm._l(_vm.filteredOptions, function(option, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "option",
                        class:
                          _vm.disabledIdList.indexOf(option[_vm.id]) !== -1
                            ? "unavalable"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.selectOption(option)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "option-checkmark" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.selectedOptions?.find(el =>
                                  _vm.id
                                    ? el?.[_vm.id] === option?.[_vm.id]
                                    : el?.[_vm.textFieldName] ===
                                      option?.[_vm.textFieldName]
                                ),
                                expression:
                                  "selectedOptions?.find(el => id ? (el?.[id] === option?.[id]) : (el?.[textFieldName] === option?.[textFieldName]))"
                              }
                            ],
                            attrs: {
                              src: require("@/drc/assets/images/check-dark.png"),
                              alt: "Check"
                            }
                          })
                        ]),
                        _vm.imageUrl
                          ? _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require(`@/${_vm.imageUrl}${
                                  option?.[
                                    _vm.imageFieldName
                                      ? _vm.imageFieldName
                                      : _vm.textFieldName
                                  ]
                                }.svg`)
                              }
                            })
                          : _vm._e(),
                        _c("span", { staticClass: "option-text" }, [
                          _vm._v(_vm._s(option?.[_vm.textFieldName]))
                        ])
                      ]
                    )
                  }),
                  _vm.canAddNew && _vm.keyWord.trim()
                    ? _c(
                        "div",
                        {
                          staticClass: "option",
                          on: { click: _vm.addNewOption }
                        },
                        [
                          _vm._m(0),
                          _c("span", { staticClass: "option-text" }, [
                            _vm._v("Add new")
                          ])
                        ]
                      )
                    : !_vm.filteredOptions?.length
                    ? _c("div", { staticClass: "option disabled" }, [
                        _vm._m(1),
                        _c("span", { staticClass: "option-text" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.errorLabel)))
                        ])
                      ])
                    : _vm._e(),
                  _vm.notValidatedOptions?.length
                    ? _c("div", { staticClass: "not-validated-text-container" })
                    : _vm._e()
                ],
                2
              ),
              _vm._l(_vm.notValidatedOptions, function(selectedOption, index) {
                return _c(
                  "span",
                  { key: _vm.field + "selectedNotValidated" + index },
                  [
                    _vm._v(
                      " " +
                        _vm._s(selectedOption?.[_vm.textFieldName]) +
                        " is not validated "
                    ),
                    _c("br")
                  ]
                )
              })
            ],
            2
          )
        ]
      ),
      typeof _vm.number !== "number" &&
      _vm.formData[_vm.field].errors?.length > 0 &&
      !_vm.isDisabled
        ? _c(
            "div",
            { staticClass: "errors" },
            _vm._l(_vm.formData[_vm.field].errors, function(error, index) {
              return _c("span", { key: index }, [
                _vm._v(" " + _vm._s(_vm.$t(`${error}`) + ".") + " ")
              ])
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "option-checkmark" }, [
      _c("img", {
        attrs: { src: require("@/drc/assets/images/check.png"), alt: "Check" }
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "option-checkmark" }, [
      _c("img", {
        attrs: {
          src: require("@/drc/assets/images/check-dark.png"),
          alt: "Check"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }